<template>
  <div class="w3-main content" style="margin-left:200px">
    <div class="navigation">
      <button
        class="w3-button w3-text-white w3-xlarge w3-hide-large"
        @click="openNav"
      >
        &#9776;
      </button>
    </div>

    <div class="content">
      <keep-alive>
        <component :is="selectedComponent"></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import intro from "./Me";
import skills from "./skills";
import experience from "./Experience";
import education from "./Education";
import projects from "./projects";
import contact from "./contact";
import certificate from "./certificates";
import { eventBus } from "../main";
export default {
  data() {
    return {
      selectedMenu: "",
    };
  },
  components: {
    intro: intro,
    skills: skills,
    experience: experience,
    education: education,
    projects: projects,
    contact: contact,
    certificate: certificate,
  },
  computed: {
    selectedComponent() {
      return this.selectedMenu != "" ? this.selectedMenu : "intro";
    },
  },
  methods: {
    openNav() {
      document.getElementById("mySidebar").style.display = "block";
    },
  },
  created() {
    eventBus.$on("selected", (value) => {
      this.selectedMenu = value;
    });
  },
};
</script>
<style>
.content {
  height: 100% !important;
}
</style>
